import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { persistTrackingParams } from "./lib/tracking";

// Captura UTM/fbclid/gclid da URL de aterrissagem ANTES do router assumir —
// funis multi-página (ex.: /evento → /evento/aplicar) dependem disso pra
// atribuição não se perder na navegação.
persistTrackingParams();

createRoot(document.getElementById("root")!).render(<App />);
